import { Pipe, PipeTransform } from '@angular/core';
import currency from 'currency.js';

import { IPromisedPayment } from '../../../advance-application/models/promised-payment.interface';

@Pipe({
  name: 'totalByPromisedList',
  standalone: true,
})
export class TotalByPromisedListPipe implements PipeTransform {
  transform(value?: IPromisedPayment[]): currency | undefined {
    if (!value) return;
    return value.reduce((acc, v) => acc.add(v.total), currency(0));
  }
}
